import type { TApiResponse } from '@/types/api-types/TApiResponse'
import type { IActivitiesApiRequest, TActivitiesRequestParams } from '@/types/api-types/activities'
import ActivitiesApiUrls from './endpoints'
import BaseApiRequest from '../BaseApiRequest'

class ActivitiesApiRequest extends BaseApiRequest implements IActivitiesApiRequest {
  async getActivitiesList(params: TActivitiesRequestParams): TApiResponse {
    const url = `${ActivitiesApiUrls.ACTIVITIES()}`
    return this.get(url, params)
  }
}

export default ActivitiesApiRequest
